module.exports = __webpack_public_path__ + "img/drop_down.fe695d02.svg";